/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Sociaalemotioneeldomein_Zelfbewustzijn4Inputs */

const nl_enums_sociaalemotioneeldomein_zelfbewustzijn4 = /** @type {(inputs: Enums_Sociaalemotioneeldomein_Zelfbewustzijn4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zelfbewustzijn`)
};

/**

* @param {Enums_Sociaalemotioneeldomein_Zelfbewustzijn4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_sociaalemotioneeldomein_zelfbewustzijn4 = /** @type {((inputs?: Enums_Sociaalemotioneeldomein_Zelfbewustzijn4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Sociaalemotioneeldomein_Zelfbewustzijn4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_sociaalemotioneeldomein_zelfbewustzijn4(inputs)
});
export { enums_sociaalemotioneeldomein_zelfbewustzijn4 as "enums.SociaalEmotioneelDomein.Zelfbewustzijn" }